<template>
  <topbar
    :titulo="$t('ACADEMICO.PERIODO_LETIVO')"
    :subtitulo="$t('ACADEMICO.PERIODO_LETIVO_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4">
        <div />
        <b-button
          variant="info"
          class="mr-md-2"
          @click="cadastrar"
          v-if="podeCadastrar"
        >
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO.ESTRUTURA_CEJ') },
        { titulo: this.$t('ACADEMICO.PERIODO_LETIVO') },
      ],
    };
  },
  methods: {
    cadastrar() {
      this.$emit('cadastrar', 'criar-periodo-letivo');
    },
  },
};
</script>
